import React, { forwardRef } from 'react';

interface VideoElementProps {
  src: string;
  fileType?: 'video' | 'image';
  poster?: string;
  isDrawingEnabled: boolean;
  isDrawingToolboxOpen?: boolean;
  onTimeUpdate: () => void;
  onLoadedMetadata: () => void;
  onEnded: () => void;
  onVideoClick: (e: React.MouseEvent) => void;
  onError: (e: React.SyntheticEvent<HTMLVideoElement | HTMLImageElement, Event>) => void;
}

const VideoElement = forwardRef<HTMLVideoElement | HTMLImageElement, VideoElementProps>(({
  src,
  fileType = 'video',
  poster,
  isDrawingEnabled,
  isDrawingToolboxOpen = false,
  onTimeUpdate,
  onLoadedMetadata,
  onEnded,
  onVideoClick,
  onError,
}, ref) => {
  if (fileType === 'image') {
    return (
      <img
        ref={ref as React.Ref<HTMLImageElement>}
        src={src}
        alt="Drawing canvas background"
        onClick={onVideoClick}
        onLoad={onLoadedMetadata}
        style={{ 
          width: '100%', 
          height: '100%',
          cursor: isDrawingToolboxOpen ? 'not-allowed' : (isDrawingEnabled ? 'crosshair' : 'pointer'),
          objectFit: 'contain',
        }}
        onError={onError}
      />
    );
  }

  return (
    <video
      ref={ref as React.Ref<HTMLVideoElement>}
      src={src}
      poster={poster}
      onTimeUpdate={onTimeUpdate}
      onLoadedMetadata={onLoadedMetadata}
      onEnded={onEnded}
      onClick={onVideoClick}
      style={{ 
        width: '100%', 
        height: '100%',
        cursor: isDrawingToolboxOpen ? 'not-allowed' : (isDrawingEnabled ? 'crosshair' : 'pointer'),
        backgroundColor: '#000',
        objectFit: 'contain',
      }}
      onError={onError}
      controls={false}
      preload="metadata"
      playsInline
      {...({ 'webkit-playsinline': 'true' } as any)}
    />
  );
});

VideoElement.displayName = 'VideoElement';

export default VideoElement; 